
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/balance",
      function () {
        return require("private-next-pages/docs/balance/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/balance"])
      });
    }
  